<template>
  <div @click.stop>
    <GrmCamstudyOptionModal v-if="step===1"
                            :title="$t('camstudy.participant.selectExitType')"
                            :list="exitOptions"
                            :button="optionModalButtons"
                            @onCloseOption="close"
                            :value="'kick'"
                            @onNextAct="selectKickOrBanUser"
    />
    <CamstudyPromptModal v-if="step===2"
                         :warning="true"
                         :button="promptModalButtons"
                         :title="$t('camstudy.participant.banReason')"
                         @onClosePrompt="close"
                         @onNextAct="banUser"
    >
      <div>
        <select class="participant-modal-select" @input="(e) => selectedBanReason.value = e.target.value">
          <option v-for="(option, i) in banReasonOption" :key="i" :value="option.value" :selected="option.value === selectedBanReason.value">{{ option.title }}</option>
        </select>
        <textarea class="etc-textarea" maxlength="30" :placeholder="$t('camstudy.participant.etcPlaceholder')" v-show="selectedBanReason.value === 'etc'" v-model="description"/>
      </div>
    </CamstudyPromptModal>
  </div>
</template>
<script>
import CamstudyPromptModal from "@/components/Common/camstudyPromptModal/CamstudyPromptModal.vue";
import GrmCamstudyOptionModal from "@/components/Common/camstudyOptionModal/GrmCamstudyOptionModal.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'KickOrBanUser',
  components: {
    CamstudyPromptModal,
    GrmCamstudyOptionModal,
  },
  props: {
    user: { type: Object, required: true },
  },
  data() {
    return {
      step: 1,
      selectedBanReason: {value: '', description: ''},
      description: '',
    }
  },
  computed: {
    ...mapGetters('user',[
      'hasEmceeRole',
    ]),
    ...mapGetters('camstudy', [
      'banReasonList',
      'getCamStudyUser',
    ]),
    banReasonOption() {
      return this.banReasonList.map(reason => {
        return {title: reason.description, value: reason.reason}
      })
    },
    exitOptions() {
      return [
        {
          value: 'kick',
          name: this.$t('camstudy.participant.kick'),
          message: this.$t('camstudy.participant.kickMessage'),
        },
        {
          value: 'ban',
          name: this.$t('camstudy.participant.ban'),
          message: this.$t('camstudy.participant.banMessage'),
        }
      ];
    },
    optionModalButtons() {
      return [this.$t('common.cancel'), this.$t('common.next')];
    },
    promptModalButtons() {
      return [this.$t('common.cancel'), this.$t('common.confirm')];
    },
  },
  methods: {
    ...mapActions('user', [
      'kickRoomUser',
    ]),
    ...mapActions('camstudy', [
      'addCamStudyUserBan',
    ]),
    close() {
      this.$emit('close')
    },
    selectKickOrBanUser(type) {
      if (!this.user?.userId || !type) return

      if (type === 'kick') {
        this.kickRoomUser({userId: this.user.userId})
        this.close()
      } else if (type === 'ban') {
        this.step = 2
        this.selectedBanReason.value = this.banReasonOption[0].value
        this.selectedBanReason.description = ''
        this.description = ''
      }
    },
    banUser() {
      if (!this.user?.userId) return

      const cu = this.getCamStudyUser(this.user.userId)
      if (!this.hasEmceeRole() || !cu) {
        return
      }
      if (!this.selectedBanReason.value) return
      if(this.selectedBanReason.value === 'etc') {
        this.selectedBanReason.description = this.description?.trim()
      }else {
          this.selectedBanReason.description = ''
      }

      this.addCamStudyUserBan({
        email: cu.email,
        banReason: this.selectedBanReason.value,
        banReasonComment: this.selectedBanReason.description
      })

      this.close()
    },
  }
}
</script>
<style scoped lang="scss">
.etc-textarea{
  width: 100%;
  resize: none;
  border-radius: 8px;
  border: 1px solid #393939;
  background: #141414;
  padding: 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  color: white;
  margin-top: 8px;
  outline: transparent;

  &::placeholder {
    color: #808080;
  }
}
.participant-modal-select{
  border-radius: 6px;
  border: 1px solid #393939;
  background: #141414;
  padding: 6px 12px;
  width: 100%;
  font-size: 14px;
  outline: transparent;
}
</style>
